import React from 'react';
import { Container, Typography, TextField, Grid, Box, Button, Card, CardContent } from '@mui/material';

const ContactPage = () => {
  return (
    <section id="contact" style={{ backgroundColor: '#333', color: 'white', padding: '60px 20px' }}>
      <Container>
        <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
          Get in Touch
        </Typography>
        <Typography variant="body1" paragraph align="center" sx={{ maxWidth: '600px', margin: 'auto' }}>
          Have a question or need assistance? We're here to help. Drop us a message, and we will get back to you as soon as possible!
        </Typography>

        {/* Contact Form in a Card */}
        <Card sx={{ backgroundColor: '#444', borderRadius: 2, boxShadow: 3, padding: 4 }}>
          <CardContent>
            <form>
              <Grid container spacing={3}>
                {/* Name Field */}
                <Grid item xs={12} sm={6}>
                  <TextField 
                    fullWidth 
                    label="Your Name" 
                    variant="outlined" 
                    color="primary" 
                    sx={{ backgroundColor: '#fff', borderRadius: 1 }}
                  />
                </Grid>

                {/* Email Field */}
                <Grid item xs={12} sm={6}>
                  <TextField 
                    fullWidth 
                    label="Your Email" 
                    variant="outlined" 
                    color="primary" 
                    sx={{ backgroundColor: '#fff', borderRadius: 1 }}
                  />
                </Grid>

                {/* Message Field */}
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Your Message" 
                    variant="outlined" 
                    color="primary" 
                    multiline 
                    rows={4} 
                    sx={{ backgroundColor: '#fff', borderRadius: 1 }}
                  />
                </Grid>
              </Grid>

              {/* Submit Button */}
              <Box sx={{ textAlign: 'center', marginTop: 3 }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  type="submit" 
                  sx={{ padding: '12px 40px', borderRadius: '25px', textTransform: 'none', '&:hover': { backgroundColor: '#1976d2' } }}
                >
                  Send Message
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Container>
    </section>
  );
};

export default ContactPage;
